// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30JhE","type":"styles_type__1hMJj","choices":"styles_choices__cF86w"};